module.exports = __webpack_public_path__ + "img/big1.73905615.jpg";